<template>
    <b-card>
        <b-row>
            <b-col>
                <dashboard-filters key="customer" :roles="rolesOptions" :officers="OfficerOptions"
                    :order-types="orderTypesOptions" @select-officer="selectedOfficer = $event"
                    @select-role="selectedRole = $event" @select-order-type="selectedType = $event"
                    @select-range="selectedRange = $event" :filters="['officer', 'role', 'orderType', 'dataRange']" />
            </b-col>
        </b-row>
        <b-row class="g-0">
            <b-col cols="12" class="mt-2">
                <h6>{{ $translate('team') }}</h6>
                <column-chart :min="0" :max="5" xtitle="Officers" ytitle="Rating" :round="5"
                    :data="teamGraph"></column-chart>
            </b-col>
            <b-col cols="12" class="mt-2">
                <h6>{{ $translate('monthly') }}</h6>
                <line-chart :min="0" :max="5" xtitle="Months" ytitle="Rating" :round="1" :data="monthlyRating"></line-chart>
            </b-col>
        </b-row>
    </b-card>
</template>

<script>
import graphMixins from '@/mixins/graphMixins'

import DashboardFilters from '@/views/Dashboard/DashboardFilters'
export default {
    name: 'CustomerCharts',
    components: {
        DashboardFilters,
    },
    mixins: [graphMixins],

    data() {
        return {}
    },
    computed: {
        teamGraph() {
            const $this = this
            // console.log("this.officers", this.officers)
            const officerOrders = this.officers.map(y => this.filteredOrders.filter(
                x => x.officer_id === y.id)
            )
            const orderOfficer = officerOrders.filter(x => x.length > 0)
            const feedbackOfficers = orderOfficer.map(orders => orders.filter(y => y.feedback)).filter(order => order.length > 0)
            const result = feedbackOfficers.flatMap(item => item.map(officer => officer.officer_id))
            const newOfficers = this.officers.filter(x =>
                result.some(y => y == x.id)
            )
            return (newOfficers || []).map(x => [
                x.name,
                $this.avgOfficerRating(x.id),
            ])
        },
        monthlyRating() {
            const $this = this
            return this.lastSixMonths.map(x => [
                this.monthNames[x.month],
                $this.monthRating(x.month, x.year),
            ])
        },
    },
    watch: {
        teamGraph: {
            handler: function (x) {
                console.log('teamGraph', x)
            },
            deep: true,
        },
    },
    created() {
        this.$store.dispatch('analytics/getDashboardData')
        this.loaded = true
    },
    methods: {
        monthRating(month, year) {
            const monthOrders = this.filteredOrders.filter(
                x => x.created_year === year && x.created_month === month && (x.feedback > 0)
            )
            const totalRating = monthOrders.reduce((sum, order) => {
                sum += order.feedback
                return sum
            }, 0)
            // console.log('month, year', month, year, totalRating, monthOrders.length)
            return totalRating / monthOrders.length
        },
        avgOfficerRating(id) {
            const officerOrders = this.filteredOrders.filter(
                x => x.officer_id === id
            )
            const ratingOfficers = officerOrders.filter(order=>order.feedback > 0)
            const totalRating = officerOrders.reduce((sum, order) => {
                sum += order.feedback
                return sum
            }, 0)
            return totalRating / ratingOfficers.length
        },
    },
}
</script>
